import getLocalString from "constants/Localization";
import { useGetReportOrganizationProfitabilityMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportOrganizationProfitability = (showSuccessMessage: boolean = false) => {
  const [mutation, { loading, data, error }] = useGetReportOrganizationProfitabilityMutation();
  const [getReportOrganizationProfitability, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportOrganizationProfitability",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportOrganizationProfitability, { ...context, data }] as const;
};

export default useGetReportOrganizationProfitability;
